import React, { useState, useRef } from 'react';
import { useLocation, Link } from 'react-router';
import { InlineStack, Box } from '@shopify/polaris';

const HoverDropdownNavLink = ({ label, basePath, items }) => {
    const location = useLocation();
    const isActive = location.pathname.startsWith(basePath);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const isSmallScreen = typeof window !== 'undefined' && window.innerWidth < 968;

    return (
        <Box
            className={`nav-dropdown ${isActive ? 'nav-link--active' : ''}`}
            onMouseEnter={!isSmallScreen ? () => setOpen(true) : undefined}
            onMouseLeave={!isSmallScreen ? () => setOpen(false) : undefined}
            onClick={isSmallScreen ? () => setOpen((prev) => !prev) : undefined}
            ref={dropdownRef}
            position="relative"
            display="inlineBlock"
        >
            <Box className="nav-dropdown-trigger">
                <InlineStack gap="100" blockAlign="center">
                    <span>{label}</span>
                </InlineStack>
            </Box>

            {open && (
                <Box className="nav-dropdown-menu">
                    {items.map((item, index) => {
                        const key = `${item.label}-${index}`;

                        if (item.to) {
                            return (
                                <Link key={key} to={item.to} className="nav-dropdown-item">
                                    {item.label}
                                </Link>
                            );
                        }

                        if (item.onClick) {
                            return (
                                <div key={key} className="nav-dropdown-item" onClick={item.onClick} role="button" tabIndex={0}>
                                    {item.label}
                                </div>
                            );
                        }

                        return (
                            <div key={key} className="nav-dropdown-item">
                                {item.label}
                            </div>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
};

export default HoverDropdownNavLink;
